import type { UseQueryOptions } from '@core/types'
import type { components as StrapiComponents } from '@core/types/clients/strapi'
import { useCoreConfig, useQuery, useStrapi } from '#imports'

export const useStrapiGameList = () => {
    const { site } = useCoreConfig()
    const strapi = useStrapi()

    function getGameListByKey(
        options: Pick<UseQueryOptions<any>, 'enabled' | 'lazy' | 'server'> = {},
        key: string
    ) {
        const { enabled = true, lazy = false, server = false } = options
        const query = useQuery<StrapiComponents['schemas']['GameList']>(async () => {
            const { data } = await strapi.GET('/game-lists/{key}', {
                params: {
                    path: { key },
                    query: { brand: site.brand }
                },
            })
            return data
        }, {
            key: key,
            lazy,
            server,
            enabled,
        })
        return query
    }

    return {
        getGameListByKey
    }
}
